import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function BreaCrumb({ fullPath }) {
    const { t } = useTranslation();
    return (
        <div className={``}>
            {
                fullPath?.map((item, index) =>
                    <span key={index} className={` ${index === fullPath.length - 1 ? 'active' : ''}`}>
                        {index === fullPath.length - 1 ? <span>{item.name}</span> : <Link to={item.path}>{item.name}</Link>}
                        {index < fullPath.length - 1 && <span className="mx-2">/</span>}
                    </span>
                )
            }
            <hr />
        </div>
    )
}

export default BreaCrumb;

